/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontProductGrid_products$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontFeaturedSection_products$ref: FragmentReference;
export type StorefrontFeaturedSection_products = {|
  +$fragmentRefs: StorefrontProductGrid_products$ref,
  +$refType: StorefrontFeaturedSection_products$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_products",
  "type": "DealerStorefrontQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductGrid_products",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '2d2c8610c5ed41f25743180021d9d7ec';
module.exports = node;
